import { useRoutes } from "react-router";

import { Lazy } from "@shared/components/ui/lazy";
import { useApp } from "@shared/features/app/hooks/use-app";
import { getAuthRoutes } from "@shared/features/auth/routes";
import { getDispatchRoutes } from "@shared/features/dispatch/routes";
import { Sentry } from "@shared/utils/init-tracking";

const NotFound = Lazy(() => import("@shared/components/not-found"), "NotFound");
const Root = Lazy(() => import("@shared/features/app/pages/root"), "Root");
const DispatchOperatorAppRoot = Lazy(() => import("@shared/features/dispatch/pages/dispatch-operator-app-root"), "DispatchOperatorAppRoot");
const DispatchPendingActivation = Lazy(() => import("@shared/features/dispatch/pages/dispatch-pending-activation"), "DispatchPendingActivation");

const AppBase: React.FC = () => {
  const { initialized } = useApp();

  const element = useRoutes([
    { path: "/", element: <Root /> },
    ...getAuthRoutes(),
    {
      path: "/pending-activation",
      element: <DispatchPendingActivation />,
    },
    {
      path: "/app",
      element: <DispatchOperatorAppRoot />,
      children: [...getDispatchRoutes()],
    },
    { path: "*", element: <NotFound /> },
  ]);

  return <>{initialized ? element : null}</>;
};

export const App = Sentry.withProfiler(AppBase);
